import Color from '@/Enums/Color.enum';
import type CreativeType from '@/Enums/Creatives/CreativeType.enum';
import { CREATIVE_TYPES_TITLES } from '@/constants/creativeLibrary';
import Clear from '@mui/icons-material/Clear';
import IconButton from '@mui/material/IconButton';
import classNames from 'classnames';

interface ICreativeChipsProps {
  selectedTypes: CreativeType[];
  handleTypeChange: (type: CreativeType) => void;
}

const CreativeChips = ({ selectedTypes, handleTypeChange }: ICreativeChipsProps) => {
  return (
    <div className='flex space-x-2'>
      {selectedTypes.map(type => (
        <div
          key={type}
          className={classNames(
            'flex items-center gap-1 border border-[#DADADA] rounded-full',
            selectedTypes.length > 1 ? 'pl-3 pr-1' : 'px-3',
          )}
        >
          <span className={`text-[${Color.Primary}] text-[14px] font-semibold text-nowrap`}>
            {CREATIVE_TYPES_TITLES[type]}
          </span>
          {selectedTypes.length > 1 && (
            <IconButton
              aria-label={`remove-${type}-type-filter`}
              onClick={() => handleTypeChange(type)}
              sx={{ padding: '4px 6px' }}
            >
              <Clear sx={{ fill: Color.Grey, width: '18px' }} />
            </IconButton>
          )}
        </div>
      ))}
    </div>
  );
};

export default CreativeChips;
